// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { FileInfoResponse } from './file-info-response';

/** See com.rev360.pms.api.controller.file.PracticeFileInfoResponse */
/* istanbul ignore next */
@GandalfModel
export class PracticeFileInfoResponse extends FileInfoResponse {

	@GandalfProperty({ designType: Number })
	fileId!: number | null;

	@GandalfProperty({ designType: String })
	fileName!: string | null;

	@GandalfProperty({ designType: String })
	mimeType!: string | null;

	@GandalfProperty({ designType: Number })
	practiceFileId!: number | null;

}
